/* Saved cart contents, not customer identity. Prices and offer eligibility remain Shopify's. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && !root.WynchCartRecoveryV1) { root.WynchCartRecoveryV1 = api; api.install(root); }
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var AGE = 7 * 86400000, MAX = 28000;
  function validId(v) { return /^\d{1,18}$/.test(String(v)); }
  function properties(value) {
    if (value == null) return {};
    if (typeof value !== 'object' || Array.isArray(value) || Object.keys(value).length > 30) throw Error('CART_PROPERTIES_INVALID');
    var out = {};
    Object.keys(value).sort().forEach(function (k) {
      if (!k || k.length > 100 || ['__proto__', 'constructor', 'prototype'].includes(k) || !['string', 'number', 'boolean'].includes(typeof value[k]) || String(value[k]).length > 500) throw Error('CART_PROPERTIES_INVALID');
      out[k] = String(value[k]);
    });
    return out;
  }
  function line(item) {
    if (!item || !validId(item.id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.quantity > 99) throw Error('CART_ITEM_INVALID');
    var out = { id: String(item.id), quantity: item.quantity, properties: properties(item.properties) };
    if (item.selling_plan !== undefined) { if (!validId(item.selling_plan)) throw Error('CART_PLAN_INVALID'); out.selling_plan = String(item.selling_plan); }
    return out;
  }
  function snapshot(cart, now) {
    if (!Array.isArray(cart.items) || cart.items.length > 40) throw Error('CART_ITEMS_INVALID');
    var codes = [];
    function discount(a) { if (a && a.type === 'discount_code' && typeof (a.code || a.title) === 'string') codes.push(a.code || a.title); }
    (cart.cart_level_discount_applications || []).forEach(discount);
    var items = cart.items.map(function (i) {
      (i.line_level_discount_allocations || i.discount_allocations || []).forEach(function (a) { discount(a.discount_application); });
      var l = { id: i.variant_id || i.id, quantity: i.quantity, properties: i.properties };
      if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) l.selling_plan = i.selling_plan_allocation.selling_plan.id;
      return line(l);
    });
    (cart.discount_codes || []).forEach(function (d) { if (d && d.applicable !== false && typeof d.code === 'string') codes.push(d.code); });
    codes = Array.from(new Set(codes));
    if (codes.length > 10 || codes.some(function (c) { return c.length > 200 || /[,\r\n]/.test(c); })) throw Error('CART_DISCOUNTS_INVALID');
    return { version: 1, saved_at: now, items: items, discounts: codes };
  }
  function parse(value, now) {
    if (typeof value !== 'string' || value.length > MAX) throw Error('CART_LINK_INVALID');
    var p = JSON.parse(decodeURIComponent(value));
    if (!p || Object.keys(p).sort().join(',') !== 'discounts,items,saved_at,version' || p.version !== 1 || !Number.isSafeInteger(p.saved_at) || p.saved_at > now + 60000 || now - p.saved_at > AGE || !Array.isArray(p.items) || !p.items.length || p.items.length > 40 || !Array.isArray(p.discounts) || p.discounts.length > 10) throw Error('CART_LINK_EXPIRED_OR_INVALID');
    p.items = p.items.map(function (i) { if (Object.keys(i).some(function (k) { return !['id', 'quantity', 'properties', 'selling_plan'].includes(k); })) throw Error('CART_ITEM_INVALID'); return line(i); });
    if (p.discounts.some(function (c) { return typeof c !== 'string' || c.length > 200 || !c || /[,\r\n]/.test(c); })) throw Error('CART_DISCOUNTS_INVALID');
    return p;
  }
  function link(cart, now, locale) {
    var p = snapshot(cart, now);
    if (!p.items.length) return '';
    var value = encodeURIComponent(JSON.stringify(p));
    if (value.length > MAX) throw Error('CART_LINK_TOO_LARGE');
    return 'https://wynch.wine/' + (locale === 'en' ? 'en/' : '') + '?wynch_cart_recovery=1#' + value;
  }
  function sameLines(cart, p) {
    function key(items) { return items.map(function (i) { return JSON.stringify(line(i)); }).sort().join('|'); }
    return key(snapshot(cart, p.saved_at).items) === key(p.items);
  }
  async function restore(p, request, existing) {
    var previous = snapshot(existing, p.saved_at), cleared = false;
    if (sameLines(existing, p)) { await request('cart/update.js', { discount: p.discounts.join(',') }); return { already_present: true }; }
    try {
      await request('cart/clear.js', {}); cleared = true;
      await request('cart/add.js', { items: p.items });
      await request('cart/update.js', { discount: p.discounts.join(',') });
      var result = await request('cart.js');
      if (!sameLines(result, p)) throw Error('CART_RESTORE_CONTENT_MISMATCH');
      return { restored: true };
    } catch (error) {
      if (cleared) {
        try { await request('cart/clear.js', {}); if (previous.items.length) await request('cart/add.js', { items: previous.items }); await request('cart/update.js', { discount: previous.discounts.join(',') }); }
        catch (_) { throw Error('CART_RESTORE_AND_ROLLBACK_FAILED'); }
      }
      throw error;
    }
  }
  function install(w) {
    var doc = w.document, timer, busy = false, dirty = false, last = '', recovering = false;
    var en = doc.documentElement.lang.indexOf('en') === 0;
    function allowed() { try { return w.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (_) { return false; } }
    async function request(path, body) {
      var response = await w.fetch((w.Shopify && w.Shopify.routes.root || '/') + path, { credentials: 'same-origin', cache: 'no-store', method: body === undefined ? 'GET' : 'POST', headers: { 'Content-Type': 'application/json', accept: 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) });
      if (!response.ok) throw Error('CART_REQUEST_FAILED');
      return response.json();
    }
    function schedule() {
      if (recovering || !allowed()) return;
      dirty = true; if (busy) return;
      w.clearTimeout(timer); timer = w.setTimeout(capture, 250);
    }
    async function capture() {
      if (recovering || !allowed() || !w.klaviyo || typeof w.klaviyo.isIdentified !== 'function' || typeof w.klaviyo.identify !== 'function') return;
      busy = true; dirty = false;
      try {
        if (await w.klaviyo.isIdentified() !== true || !allowed()) return;
        var cart = await request('cart.js'), p = snapshot(cart, Date.now());
        var signature = JSON.stringify({ items: p.items, discounts: p.discounts });
        if (signature === last || !allowed()) return;
        var url = link(cart, p.saved_at, en ? 'en' : 'de');
        await w.klaviyo.identify({ wynch_cart_restore_url: url, wynch_cart_restore_saved_at: new Date(p.saved_at).toISOString(), wynch_cart_restore_version: 1 });
        last = signature;
      } catch (_) { /* Never interrupt shopping or change identity/consent. */ }
      finally { busy = false; if (dirty) schedule(); }
    }
    function notice(text, action) {
      var box = doc.createElement('dialog'), message = doc.createElement('p'), button = doc.createElement('button');
      message.textContent = text; button.textContent = en ? 'Restore saved cart' : 'Gespeicherten Warenkorb wiederherstellen';
      box.style.cssText = 'max-width:480px;padding:28px;background:#eeece7;border:1px solid #ff6315;border-radius:12px;font:18px/1.5 Arial,sans-serif';
      box.appendChild(message);
      if (action) { button.style.cssText = 'padding:14px;border:0;border-radius:30px;background:#ff6315;color:white;cursor:pointer'; button.onclick = function () { button.disabled = true; action().catch(function () { message.textContent = en ? 'We could not restore this cart. Your previous cart has been kept where possible. Please contact hi@wynch.wine.' : 'Dieser Warenkorb konnte nicht wiederhergestellt werden. Dein bisheriger Warenkorb wurde soweit möglich erhalten. Hilfe: hi@wynch.wine.'; button.remove(); }); }; box.appendChild(button); }
      var close = doc.createElement('button'); close.textContent = en ? 'Close' : 'Schließen'; close.style.cssText = 'display:block;margin-top:16px'; close.onclick = function () { box.close(); box.remove(); recovering = false; schedule(); }; box.appendChild(close);
      doc.body.appendChild(box); box.showModal();
    }
    async function recover() {
      if (!new URLSearchParams(w.location.search).has('wynch_cart_recovery')) return;
      recovering = true;
      try {
        var p = parse(w.location.hash.slice(1), Date.now());
        var current = await request('cart.js');
        var perform = async function () { await restore(p, request, current); w.location.replace((en ? '/en/' : '/') + '?cart=0'); };
        if (!current.items.length || sameLines(current, p)) await perform();
        else notice(en ? 'There are already items in this browser’s cart. Replace them with the saved selection from your email?' : 'In diesem Browser liegen bereits Artikel im Warenkorb. Möchtest du sie durch die gespeicherte Auswahl aus deiner E-Mail ersetzen?', perform);
      } catch (_) { notice(en ? 'This saved-cart link has expired or could not be restored. Please contact hi@wynch.wine.' : 'Dieser Warenkorb-Link ist abgelaufen oder konnte nicht wiederhergestellt werden. Hilfe: hi@wynch.wine.'); }
    }
    function ready() {
      recover();
      var drawer = doc.getElementById('products-cart');
      if (drawer) new w.MutationObserver(schedule).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'x-cloak'] });
      ['cart:updated', 'cart:refresh', 'wynch:customer-product-added', 'wynch:club-cava-verified', 'wynch:club-welcome-applied', 'visitorConsentCollected'].forEach(function (name) { doc.addEventListener(name, schedule); });
      var attempts = 0;
      (function sdkReady() { schedule(); if (++attempts < 40 && (!w.klaviyo || typeof w.klaviyo.isIdentified !== 'function' || !allowed())) w.setTimeout(sdkReady, 250); })();
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  }
  return { snapshot: snapshot, parse: parse, link: link, sameLines: sameLines, restore: restore, install: install };
});
